"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNamespace = void 0;
var DEFAULT_NAMESPACE = 'hubspot';
var HS_PLUGINS = 'hsPlugins'; // TODO: use `tinymce-utils` package once it is created

var getNamespace = function getNamespace(editor) {
  if (editor.settings[HS_PLUGINS] && editor.settings[HS_PLUGINS].namespaceClass) {
    return editor.settings[HS_PLUGINS].namespaceClass;
  }

  return DEFAULT_NAMESPACE;
};

exports.getNamespace = getNamespace;